export default {
    header: {
        application: '體驗申請',
        feedback: '社群回饋',
        center: '幫助中心',
        login: '登入',
        register: '註冊',
        logout: '登出登入',
        defaultName: '未登录',
        personal: '個人中心',
        manage: '後台管理',
        logOutTitle: '提示',
        logOutMessage: '此動作將退出登錄，是否繼續？ ',
        logOutConfirm: '確定',
        logOutCancel: '取消',
    },
    router: {
        home: '首頁',
        aisearch:"AI搜索",
        center:'智能體中心',
        chat: '對話',
        file: '知識庫',
        uie: '知識抽取',
        publick:'和YAYI{name}的對話',
        globalTitle: 'YAYI雅意',
        backendManage: '後台管理',
        YAYIFile: 'YAYIFile',
        knowledgeManage: '知識庫管理',
        thumbsManage: '讚踩管理',
        QAndA: '問答記錄',
        profile: '個人中心',
        accountOverview: '帳戶總覽',
        rechargeManagement: '充值管理',
        accountRecharge: '帳戶儲值',
        rechargeDetails: '充值明細',
        expenseDetails: '消費明細',
        callStatistics: '呼叫統計',
        accountSettings: '帳戶設定',
        login: '登入',
        trialApplication: '試用申請',
        ServiceAgreement: '服務協議',
        privacyPolicy: '隱私權政策',
        uieDetail: 'UIE詳情',
        share:"分享",
    },
    fontSize: {
        small: '字号-小',
        default: '字号-中',
        large: '字号-大',
        text:"文字大小"
    },
    model: {
        title: '搶先體驗',
        describe: 'YAYI 2.0效果全面升級，AI工作助理更好的提高你的工作效率',
        describe2: '每日限量體驗',
        unit: '次',
        intelligenTitle: '高級聯網搜索',
        test:'Beta',
        intelligenDescribe: '深度剖析問題，將復雜問題拆解為相互關聯的子問題，確保每個問題具有明確的指向性。通過深度檢索，搜集權威的信源資料，快速分析並總結的智能助手。',
        // intelligenDescribe: 'YAYI 2.5預置了所有插件服務（CV理解、長文、文件解析、天氣、計算器、聯網、聞海），模型會基於問題判斷自動調取插件並回答問題。 ',
    },
    tips:{
        title:'雅意YAYI-2024/6/13版本',
        add:'重點更新內容',
        tips1:'YAYI 2.5-高級聯網問答',
        info1:'對用戶提出的復雜問題，將拆解為多個相互關聯的子問題，通過深度檢索，搜集權威的信源資料，並快速分析總結。',
        tips2:'智能體-應用配置升級',
        info2:'新增智慧搜索專家，並基於用戶使用習慣，支持按全部、熱門、我的切換智能體。',
        tips3:'指令應用-引用便捷高效',
        info3:'優化指令的使用路徑，置於輸入框上方；用戶只需輸入「/+關鍵詞」，即可快速搜索指令。',
        tips4:'長文檔問答',
        info4:'支持添加多個文檔、多個URL，支持基於文檔多輪對話。',
        btn:"立即體驗",
        modelTipsTitle:'YAYI 2.5 功能上線啦～',
        tip1:'1.點擊上方切換功能',
        tip2:'2.YAYI 2.5 支持高級聯網搜索',
        infoMessage:'該模型暫不支持URL解析，請使用雅意',
        infoMessage1:'URL數量已達到上線',
        infoMessage2:'暫不支持該標簽',
        ignore:"忽略此版本"
    }
}